module.exports = __webpack_public_path__ + "static/media/aqaba-football-stadium.31b147dd.jpg";